import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute({ children }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div className="min-h-screen grid place-items-center bg-background text-muted-foreground font-mono-ui text-sm">
                Verifying session…
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    if (user.role !== "admin") {
        return (
            <div className="min-h-screen grid place-items-center bg-background text-center px-6">
                <div>
                    <div className="text-[11px] tracking-[0.24em] uppercase text-muted-foreground mb-3">403</div>
                    <div className="font-editorial text-5xl tracking-tighter">Admin access only.</div>
                </div>
            </div>
        );
    }
    return children;
}
